import React from 'react';
import { FormattedMessage } from 'react-intl';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import reducer from './reducer';
import { fileUploaded } from './actions';
import { makeSelectQuotattionAttachments } from './selectors';

import { getPlainRequestHeadersAsLogged } from '../../utils/auth';

import messages from './messages';
import configs from 'configs';

import { Alert, Row, Col, Form, Button, Icon, Divider, Collapse, Upload, Progress } from 'antd';
import 'antComponentsStyle';

class DocumentsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      proposal: props.proposal,
      attachments: [],
      isUploading: {},
      error: null
    };
  }

  componentDidMount() {
    const { proposal, quotationAttachments } = this.props;
    let attachments = proposal.quotation && proposal.quotation.data.attachments
                        ? proposal.quotation.data.attachments.data
                        : [];

    attachments = attachments.map(attachment => ({
        label: attachment.title,
        type: attachment.description,
        link: attachment.link,
        files: attachment.files.data.length ||
              (quotationAttachments.hasOwnProperty(attachment.description) ? quotationAttachments[attachment.description] : []).length || 0
      })
    );

    this.setState({attachments});
  }

  get hasUploadedAttachments() {
    return (this.state.attachments.filter(attachmentGroup => attachmentGroup.files === 0)).length === 0;
  }

  handleUploadChange = (uploadInfo, attachmentsGroupTarget) =>  {
    this.setState({
      error: null
    });

    if (uploadInfo.file.status === 'uploading') {
      this.setUploadingPercent(attachmentsGroupTarget, uploadInfo.file.percent);
    } else {
      if (uploadInfo.file.status === 'done') {
        this.setUploadingPercent(attachmentsGroupTarget, false);

        let attachments = this.state.attachments;
        let attachmentsGroupState = attachments.findIndex(attachmentsGroupItem => attachmentsGroupItem.type === attachmentsGroupTarget);
        attachments[attachmentsGroupState].files++;

        this.setState({attachments});
        this.props.fileUploaded({
          filename: uploadInfo.file.name,
          group: attachmentsGroupTarget
        })
      } else {
        this.setState({
          error: uploadInfo.file.response.message || true
        });
      }
    }
  }

  setUploadingPercent = (target, value) => {
    this.setState({
      isUploading: { ...this.state.isUploading, [target]: value === false ? value : Math.round(value) },
    });
  }

  isUploadingTarget = target => {
    const { isUploading } = this.state;
    return  isUploading[target] !== undefined && isUploading[target] !== false;
  }

  render() {
    const { hasErrors, proposal, onNext, onPrev } = this.props;
    const { attachments, isUploading, error } = this.state;
    const uploadError = hasErrors || error || false;

    return (
      <>
        <div id="TopBanner" className="element-box">
          <FormattedMessage {...messages.documentsUploadDescription} />
        </div>
        {uploadError && (
          <Alert
            type="error"
            isOpen={uploadError}
            closable
            message={typeof uploadError === 'string' ? uploadError : <FormattedMessage {...messages.alertError} />}
          />
        )}

        <Collapse
          accordion
          expandIconPosition="right"
          bordered={false}
        >
          {attachments.map(attachmentsGroup => (
            <Collapse.Panel
              key={attachmentsGroup.label}
              forceRender={true}
              disabled={!proposal.stillValid}
              showArrow={!(proposal.quotation.data.hasAttachments && !attachmentsGroup.files)}
              header={
                <>
                  <Icon
                    type="check-circle"
                    theme="twoTone"
                    twoToneColor={
                      proposal.quotation.data.hasAttachments || attachmentsGroup.files > 0 ? '#52c41a' : '#d9d9d9'
                    }
                    className="mr-2"
                  />
                  <strong>
                    {attachmentsGroup.label}
                  </strong>
                  {attachmentsGroup.link ?
                  <span className="upload-link-document">
                    <a href={attachmentsGroup.link} target="_blank" aria-label={'Scarica Documento'}>
                      Scarica <Icon type="link" />
                    </a>
                  </span> : null}
                  <span className="pull-right text-muted d-none d-lg-inline">
                    {proposal.quotation.data.hasAttachments && !attachmentsGroup.files
                      ? <>
                        <span className="d-none d-xl-inline pl-1">
                          Documentazione presente
                        </span>
                      </>
                      : <>
                        {attachmentsGroup.files}
                        <span className="d-none d-xl-inline pl-1">
                          file {attachmentsGroup.files === 1 ? 'caricato' : 'caricati'}
                        </span>
                      </>
                    }
                  </span>
                </>
              }
              className="documents-upload-container"
            >
              {attachmentsGroup.files[1] ? attachmentsGroup.files[1].key : ''}
              <Upload
                accept="application/pdf"
                listType="text"
                multiple={true}
                action={`${process.env.API_URL}quotations/documents/upload`}
                showUploadList={false}
                headers={getPlainRequestHeadersAsLogged()}
                data={{
                  quotation: proposal.quotation.data.code,
                  file_type: attachmentsGroup.type,
                }}
                onChange={(uploadInfo => this.handleUploadChange(uploadInfo, attachmentsGroup.type))}
              >
                <Button size="large">
                  <Icon type="upload" /> Carica i tuoi file
                </Button>
                {this.isUploadingTarget(attachmentsGroup.type) &&
                  <Progress
                    type="circle"
                    status={
                      this.isUploadingTarget(attachmentsGroup.type) && uploadError
                      ? 'exception'
                      : isUploading[attachmentsGroup.type] === 100
                        ? 'success'
                        : 'normal'
                    }
                    width={40}
                    strokeColor={{
                      '0%': '#007bff',
                      '100%': '#2ec58d',
                    }}
                    percent={isUploading[attachmentsGroup.type]}
                  />
                }
              </Upload>
            </Collapse.Panel>
          ))}
        </Collapse>
        <Divider />
        <Row gutter={16} className="mt-4">
          <Col md={12}>
            <Form.Item>
              <Button
                size="large"
                onClick={onPrev}
                icon="arrow-left"
                type="link"
              >
                <FormattedMessage {...messages.back} />
              </Button>
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item className="text-right">
              <Button
                size="large"
                className={`btn-primary ${proposal.stillValid ? null : 'disabled'}`}
                type="primary"
                disabled={(configs.quotationDocumentsUploadStrict && !this.hasUploadedAttachments) || !proposal.stillValid}
                onClick={onNext}
              >
                <FormattedMessage {...messages.ahead} />
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    fileUploaded: params => dispatch(fileUploaded(params)),
  };
}

const mapStateToProps = createStructuredSelector({
  quotationAttachments: makeSelectQuotattionAttachments(),
});

const withReducer = injectReducer({ key: 'quote', reducer });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withConnect,
)(DocumentsForm);
